import React from "react"
import { useBooking } from "@/context/booking"

const ContentSection: React.FC = () => {
  const { openModal } = useBooking()

  return (
    <div className="w-full mx-auto max-w-[1699px] px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col gap-6 pt-12 pb-0 px-0 m-0 text-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">
              Địa điểm
            </h2>
          </div>

          <div>
            <div className="text-base md:text-lg text-gray-700 mb-2 italic">
              <strong>- 0772 777 007 (Thiền Trúc - Thủ Đức)</strong>
            </div>
            <div className="text-base md:text-lg text-gray-700 mb-4 italic">
              <strong>- 0906 830 248 (Thiền Trúc Premium - Tân Định)</strong>
            </div>
          </div>

          <div>
            <p className="text-base md:text-lg text-gray-700 italic">
              <strong>Email: thientruc@gmail.com</strong>
            </p>
          </div>
        </div>

        <div className="w-full mx-auto">
          <hr className="border-t border-black my-8" />
        </div>

        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center mb-16">
          <div className="flex-1 text-center lg:text-left">
            <h3 className="text-2xl lg:text-3xl font-bold text-gray-800 mb-6">
              Thiền Trúc Premium
            </h3>

            <div className="space-y-4 text-gray-700 leading-relaxed text-justify">
              <p className="text-base lg:text-lg">
                Khai mở tại{" "}
                <strong>41/5 Trần Nhật Duật, Phường Tân Định</strong>, Thiền
                Trúc Premium được ấp ủ như một ốc đảo nhỏ để bạn tạm dừng giữa
                nhịp sống hối hả. Không gian nơi đây mang nét hiện đại, nhưng
                khéo léo đan xen chất liệu xưa cũ: tường gạch mộc, cửa gỗ, những
                góc nhỏ gợi nhớ về một Sài Gòn an yên. Ánh sáng ban mai len qua
                khung cửa, chạm vào từng chi tiết, làm dịu tâm trí ngay khi bạn
                vừa bước vào.
              </p>

              <p className="text-base lg:text-lg">
                Thiền Trúc Premium như một chiếc cầu nối giữa hôm nay và ngày
                xưa nơi bạn có thể thưởng thức món chay trong sự tĩnh lặng, chậm
                rãi cảm nhận hương vị, và để tâm hồn được nghỉ ngơi. Mỗi bữa ăn
                nơi đây giống một cuộc trò chuyện nhẹ nhàng với chính mình, với
                thiên nhiên quanh bạn.
              </p>
            </div>

            <button
              className="mt-6 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-medium transition-colors duration-200"
              onClick={() => openModal()}
            >
              Đặt bàn tại Thiền Trúc Premium
            </button>
          </div>

          <div className="flex-1 relative">
            <div className="relative w-full h-96 lg:h-[500px] overflow-hidden">
              <img
                src="./web-ttmi/location/c-2.jpg"
                alt="Thiền Trúc Premium Interior"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 left-4 bg-black bg-opacity-50 text-white px-3 py-1 rounded">
                Thiền Trúc Premium
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mx-auto">
          <hr className="border-t border-black my-8" />
        </div>

        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
          <div className="flex-1 text-center lg:text-left">
            <h3 className="text-2xl lg:text-3xl font-bold text-gray-800 mb-6">
              Thiền Trúc Thủ Đức
            </h3>

            <div className="space-y-4 text-gray-700 leading-relaxed text-justify">
              <p className="text-base lg:text-lg">
                Nằm tại <strong>4/4 Đường số 3, Phường Hiệp Bình Phước</strong>,
                Thiền Trúc Thủ Đức mở ra một không gian sáng sủa, tinh tế và
                rộng thoáng. Kiến trúc hiện đại được kết hợp cùng mảng xanh,
                mang đến cảm giác tươi mới, trẻ trung. Ánh sáng tự nhiên tràn
                ngập khắp không gian, những đường nét tối giản giúp thực khách
                dễ dàng thả lỏng, để tâm trí được “thở” giữa ngày dài.
              </p>

              <p className="text-base lg:text-lg">
                Tại đây, mỗi bữa ăn được chăm chút như một nghi thức nhỏ để tái
                tạo năng lượng. Khi ngồi xuống, bạn có thể cảm nhận sự thư thái
                như đang ngồi trong một khu vườn mở nơi gió nhẹ khẽ lùa và hương
                vị món ăn trở thành một phần của sự tĩnh tại ấy.
              </p>
            </div>

            <button
              className="mt-6 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-medium transition-colors duration-200"
              onClick={() => openModal()}
            >
              Đặt bàn tại Thiền Trúc Thủ Đức
            </button>
          </div>

          <div className="flex-1 relative">
            <div className="relative w-full h-96 lg:h-[500px]  overflow-hidden">
              <img
                src="./web-ttmi/location/c-1.jpg"
                alt="Thiền Trúc Thủ Đức Interior"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 left-4 bg-black bg-opacity-50 text-white px-3 py-1 rounded">
                Không gian
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentSection
